export enum Section {
    NEW_PREPAID_INDIV                ,
    NEW_PREPAID_CORP                 ,
    NEW_POSTPAID_INDIV               ,
    NEW_POSTPAID_CORP                ,
	NEW_HYBRID_INDIV                 ,
    NEW_HYBRID_CORP                  ,
    MODIFY_PREPAID_INDIV             ,
    MODIFY_PREPAID_CORP              ,
    MODIFY_POSTPAID_INDIV            ,
    MODIFY_POSTPAID_CORP             ,
    MODIFY_HYBRID_INDIV              ,
    MODIFY_HYBRID_CORP               ,
    EXISTING_ADD_PROD_PREPAID_INDIV  ,
    EXISTING_ADD_PROD_PREPAID_CORP   ,
    EXISTING_ADD_PROD_POSTPAID_INDIV ,
    EXISTING_ADD_PROD_POSTPAID_CORP  ,
    TRANSFER_REG                     ,
    TERMINATE_SERVICE_INDIV          ,
    TERMINATE_SERVICE_CORP           ,
    AGENT_ROLES                      ,
    AGENT_FORGOT_PASSWORD            ,
    AGENT_FORGOT_USERNAME            ,
    AGENT_DETAILS                    ,
    AGENT_SIGN_UP                    ,
    AGENT_RESET_PASSWORD             ,
    AGENT_CHANGE_PASSWORD            ,
    AGENT_MEMORABLE_QUESTIONS        ,
    AGENT_SIGN_IN                    ,
    AGENT_CONTACT_INFORMATION        ,
    AGENT_ADDRESS_DETAILS            ,
    AGENT_LOCATIONS                  ,
    AGENT_SIMS                       ,
    AGENT_PERMISSIONS                ,
    AGENT_ACTIONS                    ,
    CUSTOMER_PERSONAL_DETAILS        ,
    SETTINGS_SECURITY_QUESTIONS      ,
	NEW                              ,
	EXISTING                         ,
	OFFNET                           ,
	MOMO                             ,
	MODIFY                           ,
	MODIFY_MOMO          			 ,
	TRANSFER_REGISTRATION_INDIV		 ,
	TRANSFER_REGISTRATION_CORP		 ,
	SELF_REG           				 ,
	SIM_SWAP           				 ,
	REIDENTIFICATION   				 ,
	ISP								 ,
	ADD_SIM							 ,
	STARTER_KIT						 ,
	SPONSOR_REG						 ,
	MNP								 ,
	API_CORPORATE_REG				 ,
	MOMOKASH_AGENT_CREATION          ,
	MOMOKASH_HANDLER_POS_CREATION    ,
	MOMOKASH_MERCHANT_CREATION       ,
	MOMOKASH_UPDATE_AGENT_ACCOUNT    ,
	MOMOKASH_UPDATE_POS_NUMBER       ,
	MOMOKASH_ATTACH_AGENT_HIERARCHY  ,
	MOMOKASH_AGENT_MODIFY            ,
	MOMOKASH_HANDLER_POS_MODIFY      ,
	MOMOKASH_MERCHANT_MODIFY         ,
	MNP_MODIFY                       ,
	SPONSOR_MODIFY                   ,
	STARTER_KIT_MODIFY               ,
}

export enum DynamicInputField {
    CAMERA           = 'camera',
    DATE             = 'date',
	DATE_MANUAL      = 'date_manual',
    DROPDOWN         = 'dropdown',
	DROPDOWN_FILTER  = 'dropdown_filter',
    INPUT            = 'input',
    PASSWORD         = 'password',
    PASSWORD_CURRENT = 'password_current',
    SIGNBOX          = 'signbox',
    TICKBOX          = 'tickbox',
    MAP              = 'map',
    CHOOSER          = 'chooser',
    ADD_BUTTON       = 'add_button',
    BUTTON           = 'button',
    LINK             = 'link',
	DISPLAY_CONTRACT = 'display_contract',
}

export enum DynamicCharType {
    ALPHA        = 'alpha',
    ALPHANUMERIC = 'alphanumeric',
    BLOB         = 'blob',
    DATE         = 'date',
    EMAIL        = 'email',
    LOV          = 'lov',
    MSISDN       = 'msisdn',
    NUMERIC      = 'numeric',
    PASTDATE     = 'pastdate',
    FUTUREDATE   = 'futuredate',
    BIRTHDATE    = 'birthdate',
    JSON         = 'json',
}

/**
 * Enums derived from DYNAMIC_FIELD_ACTION_RULE table,
 * TYPE column.
 * These are the rules the calling code must apply to the
 * given dynamic field
 */
 export enum ActionRule {
    /* Make the field mandatory */
    MANDATORY     = "MANDATORY",
    /* Make the field non-mandatory */
    NON_MANDATORY = "NON-MANDATORY",
    /* Regex to apply on the field */
    REGEX         = "REGEX",
    /* Set the minimum value on the field */
    MIN           = "MIN",
    /* Set the maximum value on the field */
    MAX           = "MAX",
    /* Set the field to enabled */
    ENABLE        = "ENABLE",
    /* Set the field to disabled */
    DISABLE       = "DISABLE",
    /* Hide the field */
    HIDE          = "HIDE",
    /* Show the field */
    SHOW          = "SHOW",
    /* Indicates that the validation failed, and
    user must resolve before proceeding */
    INVALID       = "INVALID",
	/* Change the properties of a dynamic field */
	CHANGE_PROP   = "CHANGE PROP",
	/* Indicates that server side validation must execute - uses dynamic_validation / dynamic_validation_mappipng*/
	VALIDATE      = "VALIDATE",
}

export enum Field {
    AGENT_AGE_RANGE                           = 340,
    FIRST_NAME                                = 279,
    MIDDLE_NAME                               = 280,
    LAST_NAME                                 = 281
}

export enum LinkedListType {
    CASCADE = 'cascade',
    FLAT    = 'flat'
}